import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: true,
    error: '',
    salesInvoiceDetails: '',
    salesTransactionDetails: '',
};

export default function salesTransactionsReducer(state = initState, action) {
    switch (action.type) {
        case actions.SALES_INVOICE_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.SALES_INVOICE_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                salesInvoiceDetails: action.payload,
            };
        }
        case actions.SALES_INVOICE_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.SALES_TRANSACTION_DETAILS_START: {
            return {
                ...state,
                loader: true,
            };
        }
        case actions.SALES_TRANSACTION_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                salesTransactionDetails: action.payload,
            };
        }
        case actions.SALES_TRANSACTION_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }

        case actions.CLEAR_SALES_TRANSACTION_DETAILS_START: {
            return initState;
        }
        case actions.CLEAR_SALES_TRANSACTION_DETAILS_SUCCESS: {
            return initState;
        }
        default:
            return state;
    }
}